export default class Recaptcha {
	public static initialize() {
		const recaptchaScript = document.createElement("script");
		recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`;
		recaptchaScript.defer = true;
		recaptchaScript.async = true;
		document.head.appendChild(recaptchaScript);
	}
}
